import { ButtonV2, Progress } from '@cimplico/components';
import { useState } from 'react';
import { Subscription } from '../../../../../types/firm';
import EditEntityAllocationDialog from './EditEntityAllocationDialog';
import SectionLabel from '../../../../../components/section-label/SectionLabel';
import SettingsContainer from '../../../../../components/settings-container/SettingsContainer';

type ActiveEntitiesProps = {
    subscription: Subscription;
};

function ActiveEntities({ subscription }: ActiveEntitiesProps): JSX.Element {
    const [editing, setEditing] = useState(false);

    const used = subscription.activeEntities.count;
    const allocated = subscription.activeEntities.allocation;

    const percent = (used / allocated) * 100;

    return (
        <>
            <EditEntityAllocationDialog isOpen={editing} onClose={(): void => setEditing(false)} subscription={subscription} />
            <SettingsContainer>
                <SectionLabel
                    title="Active entities & individuals"
                    description="An active entity or individual refers to an entity / individual that has had at least one open workpaper during the annual billing period."
                />
                <div className="grid gap-y-8">
                    <section className="grid gap-y-2 text-xs text-gray-600 dark:text-gray-400">
                        <p className="font-medium">Remaining entities</p>
                        <Progress percent={percent} />
                        <p>
                            {used} of {allocated} used
                        </p>
                    </section>
                    <section className="grid gap-y-2 text-xs text-gray-600 dark:text-gray-400">
                        <p className="font-medium">Active individuals</p>
                        <span className="text-gray-800 dark:text-gray-200">{subscription.activeIndividuals.count}</span>
                    </section>
                    <div className="w-fit">
                        <ButtonV2
                            size="sm"
                            type="secondary"
                            label="Edit quota"
                            onClick={(): void => setEditing(true)}
                            disabledHint={
                                subscription.status !== 'ACTIVE'
                                    ? 'Quota can only be changed for active subscriptions.'
                                    : subscription.isBespokeAgreement
                                    ? 'This subscription is a bespoke agreement and cannot be updated. Please contact support.'
                                    : undefined
                            }
                            isDisabled={subscription.status !== 'ACTIVE' || subscription.isBespokeAgreement}
                        />
                    </div>
                </div>
            </SettingsContainer>
        </>
    );
}

export default ActiveEntities;
